'use client';

import { useTranslation } from '@root/src/i18n/client';
import CollectionTitle from './collectiontitile';
import FeaturedProduct from './featureProduct';

import OtherCollections from './othercollection';
import ProductGrid from './productionGrid';
import HeroBanner from './herobannertop';

interface CollectionPageProps {
  collection: {
    id?: string | number;
    name: string;
    description?: string;
    slug?: string;
    image?: string[] | string;
    appear?: string;
    order?: string | number;
  };
  products?: Array<any>;
  collections?: Array<any>;
}

export default function CollectionPage({
  collection,
  products = [],
  collections = [],
}: CollectionPageProps) {
  const { t } = useTranslation('common');
  const collectionData = collection || {
    name: t('lytra.collectionFallbackName'),
    description: t('lytra.collectionFallbackDesc'),
    image: undefined,
  };

  return (
    <div className="page-wrapper lytra-collection-page">
      <HeroBanner collection={collectionData} />
      <CollectionTitle collection={collectionData} />
      <ProductGrid parentSlug={collection?.slug} products={products} />
      <FeaturedProduct collection={collectionData} />
      {/* Second row of products is included within ProductGrid pagination */}
      <div className="other-collections-wrapper">
        <OtherCollections collections={collections} />
      </div>

      <style jsx>{`
        .lytra-collection-page {
          width: 100%;
          overflow-x: hidden;
          background: #faf7f2;
        }
        .other-collections-wrapper {
          width: 100%;
        }
      `}</style>
    </div>
  );
}
